require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-jordana-gustafson.json") })
        }
      }, "path---blog-author-jordana-gustafson");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-jordana-gustafson!./.cache/json/blog-author-jordana-gustafson.json
// module id = 661
// module chunks = 231608221292675